var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrestigePhotographywithCompanion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6989:32487)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.87437 11.0411C8.17154 11.0411 9.2231 9.94848 9.2231 8.60064C9.2231 7.2528 8.17154 6.16016 6.87437 6.16016C5.5772 6.16016 4.52563 7.2528 4.52563 8.60064C4.52563 9.94848 5.5772 11.0411 6.87437 11.0411Z",
    stroke: "#404041",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.295 13.7224H1.37622C0.823937 13.7224 0.376221 13.2746 0.376221 12.7224V6.11907C0.376221 5.56679 0.823936 5.11907 1.37622 5.11907H3.00317C3.38761 5.11907 3.73801 4.89868 3.90451 4.55217L4.47366 3.36768C4.64016 3.02117 4.99057 2.80078 5.37501 2.80078H8.18508C8.55 2.80078 8.88594 2.99956 9.0616 3.31941L9.76511 4.60044C9.94077 4.92029 10.2767 5.11907 10.6416 5.11907H12.3726C12.9196 5.11907 13.3651 5.55856 13.3725 6.1055L13.3998 8.11671",
    stroke: "#404041",
    strokeWidth: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.0402,
    cy: 12.5034,
    rx: 2.8,
    ry: 2.88235,
    stroke: "#404041",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7874 12.5011H13.294M12.0407 13.7913V11.2109",
    stroke: "#404041",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8325 16.5466V17.6195C11.8325 17.8254 11.9588 18.0103 12.1506 18.0852L15.7661 19.4977C15.9099 19.5539 16.0715 19.5405 16.204 19.4615L19.3879 17.5645C19.5392 17.4743 19.6319 17.3112 19.6319 17.135V13.7104C19.6319 13.4975 19.4971 13.3079 19.296 13.2381L15.7322 12",
    stroke: "#404041",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 14.8008L15.9229 14.9773",
    stroke: "#404041",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3719 13.3477L15.9922 14.9734V19.5796",
    stroke: "#404041",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6989:32487"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrestigePhotographywithCompanion);
export default __webpack_public_path__ + "static/media/PrestigePhotographywithCompanion.fa1b1cd9166fd1b893c2a2cbbcf32a8d.svg";
export { ForwardRef as ReactComponent };